import { Descriptions, Typography } from "antd";
import { currencyFormat } from "./PartnerViewTable";

const { Text } = Typography;

type DefaultPartnerViewProps = {
  selectedMonth: any;
  partnerView: any;
};

export const DefaultPartnerView = ({
  selectedMonth,
  partnerView,
}: DefaultPartnerViewProps) => {
  return (
    <>
      <Descriptions
        bordered
        size="small"
        column={{ xxl: 2, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }}
        labelStyle={{ width: "25%", fontWeight: 600, backgroundColor: "#fbfcfd", color: "#475569", fontSize: "12px" }}
        contentStyle={{ width: "25%", backgroundColor: "#fff", fontSize: "13px", fontWeight: 500, color: "#1e293b" }}
        style={{ marginBottom: '16px' }}
      >
        <Descriptions.Item label={"Borrower"}> {partnerView.borrower} </Descriptions.Item>
        <Descriptions.Item label={"Approved Amt"}>
          <Text strong style={{ fontSize: '15px' }}>{currencyFormat(partnerView.approved_amount)}</Text>
        </Descriptions.Item>
        <Descriptions.Item label={"Product Type"}> {partnerView.product_type} </Descriptions.Item>
        <Descriptions.Item label={"Terms"}>
          <span style={{ backgroundColor: '#fffbe6', padding: '2px 4px' }}>{selectedMonth.months_to_pay}</span>
        </Descriptions.Item>
        <Descriptions.Item label={"Interest Rate"}>
          {(selectedMonth.interest_rate * 100).toFixed(4)}%
        </Descriptions.Item>
        <Descriptions.Item label={"PF Rate"}>
          {(partnerView.pf_rate * 100).toFixed(2)}%
        </Descriptions.Item>
      </Descriptions>
      
      <Descriptions
        bordered
        size="small"
        column={1}
        labelStyle={{ width: "50%", fontWeight: 600, backgroundColor: "#fff", color: "#475569", fontSize: "12px" }}
        contentStyle={{ width: "50%", backgroundColor: "#fff", fontSize: "13px", fontWeight: 500, color: "#1e293b" }}
        style={{ marginBottom: '16px' }}
      >
        <Descriptions.Item label="Total Approved Amount (with PF)">
          <Text strong style={{ fontSize: "15px" }}>{currencyFormat(partnerView.total_approved_amount_with_pf)}</Text>
        </Descriptions.Item>
        <Descriptions.Item label="Terms">
          {selectedMonth.months_to_pay}
        </Descriptions.Item>
        <Descriptions.Item label="Interest Rate">
          {(selectedMonth.interest_rate * 100).toFixed(4)}%
        </Descriptions.Item>
      </Descriptions>

      <div style={{ fontWeight: 700, marginBottom: '8px', fontSize: '13px', color: '#1e293b', paddingLeft: '8px' }}>Charges</div>
      <Descriptions
        bordered
        size="small"
        column={1}
        labelStyle={{ width: "50%", fontWeight: 600, backgroundColor: "#fff", color: "#475569", fontSize: "12px" }}
        contentStyle={{ width: "50%", backgroundColor: "#fff", fontSize: "13px", fontWeight: 500, color: "#1e293b" }}
      >
        <Descriptions.Item label="Processing fee (100%)">
          {currencyFormat(partnerView.proc_fee)}
        </Descriptions.Item>
        <Descriptions.Item label="Net proceed">
          <Text strong style={{ fontSize: "14px", color: "#1e293b" }}>{currencyFormat(partnerView.net_proceed)}</Text>
        </Descriptions.Item>
        <Descriptions.Item label="Monthly Amort">
          <Text strong style={{ fontSize: "16px", color: "#f97316" }}>{currencyFormat(selectedMonth.monthly_amount)}</Text>
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};
